import React, { useState, useEffect } from "react"
import Leaflet from "leaflet"
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet"
import "leaflet/dist/leaflet.css"

import axios from 'axios';
import { SAMPLINGPOINTS } from 'helpers/url_helper';
import { Config, TOAST_OPTIONS } from 'helpers/backend_helper';
import toastr from "toastr";
import "toastr/build/toastr.min.css";

import LoadingOverlay from 'react-loading-overlay';
import BounceLoader from 'react-spinners/BounceLoader'

Leaflet.Icon.Default.imagePath = "../node_modules/leaflet"

delete Leaflet.Icon.Default.prototype._getIconUrl

Leaflet.Icon.Default.mergeOptions({
  iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png'
})

const HWAMap = () => {
   

    const centerPosition = [9.583397, 44.083651]
    const [points, setPoints] = useState([9.583397, 44.083651])
    const [isloading, setIsloading] = useState(false);
    
    return (
      <LoadingOverlay
        active={isloading}
        spinner={<BounceLoader />}
        text='Please wait...'
        >
          <MapContainer
            center={points}
            zoom={15}
            style={{ height: "200px" }}
            attributionControl={true}
            zoomControl={false}
            doubleClickZoom={true}
            scrollWheelZoom={true}
            dragging={true}
            animate={true}
            easeLinearity={0.35}
          >
            <TileLayer
              attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
        
          
                    <Marker  position={points}>
                        <Popup>
                            <strong>Hargeysa Water Agency Head Office</strong>
                        </Popup>
                    </Marker>
   
          </MapContainer>
        </LoadingOverlay>
    )
  }
export default HWAMap;
